// Canonical helpers for a user's "handle" — their emoji plus username.
// Centralised so every surface (leaderboards, profiles, comments, …) renders
// the same `<emoji>.<username>` format and the same fallback for emoji-less users.

/** Shown in place of a user's emoji when they haven't set one. */
export const NO_EMOJI_FALLBACK = "👤";

/** A user's emoji, or the shared fallback when they don't have one. */
export function resolveUserEmoji(userEmoji?: string | null): string {
  return userEmoji && userEmoji.trim() ? userEmoji : NO_EMOJI_FALLBACK;
}

/**
 * Full display handle as a single string, e.g. "🎨.nassos".
 * Falls back to the shared emoji when the user has none ("👤.nassos").
 */
export function formatUserHandle(username: string, userEmoji?: string | null): string {
  return `${resolveUserEmoji(userEmoji)}.${username}`;
}
